import { Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { UserService } from '../../services/user.service';
import { RoleService } from '../../services/role.service';
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { Dropdown } from "primeng/dropdown";
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver/src/FileSaver';
import { maxYearFunction } from '../../_helpers/utility';
import * as moment from "moment";
import { CategoryService } from 'src/app/services/category.service';
import { MultiSelect } from 'primeng/multiselect';
import { CommonService } from '../../services/common.service';
import { FormBuilder, FormGroup, Validators } from "@angular/forms"
import { FileUpload } from 'primeng/fileupload';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface PaymentMethod {
    name: string,
}
@Component({
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    styles: [`
        :host ::ng-deep .p-datatable-gridlines p-progressBar {
            width: 100%;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService]
})
export class UserComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    public hide: boolean = true;
    imageSize = environment.imageSize;
    methods: PaymentMethod[];
    selectedMethod: PaymentMethod;
    items: MenuItem[] | undefined;
    errorMessage = '';
    statuses: any[];
    searchBy: any[];
    rowGroupMetadata: any;
    totalRecords: 0;
    virtualDatabase: any;
    userlist: any;
    userRoleId;
    userdetail: any;
    public item: any[] = [];
    genders: any = [];
    ageGroupList: any = [];
    paymentType: boolean = false;
    userId: any;
    paymentReject: boolean = false;
    id: any = [];
    loading: boolean;
    paginationOption;
    private lastTableLazyLoadEvent: LazyLoadEvent;
    calvalue: Date;
    ucalvalue: Date;
    dcalvalue: Date;
    yearRange;
    minYear = environment.minYear;
    startDate: Date;
    endDate: Date;
    downloadFlg: boolean;
    downloadUserList: any;
    searchby;
    wdcalvalue;
    selectedFilter: any = null;
    userFilterByList: any[] = [
        // { name: 'Profile Completed And Mobile Verified', key: 'PCMV' },
        // { name: 'Profile Completed And Mobile Not Verified', key: 'PCMNV' },
        { name: 'All', key: 'A' },
        { name: 'Incomplete profile And Mobile Verified', key: 'IPMV' },
        //{ name: 'Incomplete profile And Mobile Not verified', key: 'IPMNV' },
        { name: 'Video Rejected', key: 'VR' },
        { name: 'Video Approved', key: 'VA' },
        //{ name: 'All', key: 'A' },

    ];
    userCategories = environment.userCategories;
    @ViewChild("dt", { static: false }) public dt: Table;
    @ViewChild("pDropDownId1", { static: false }) pDropDownId1: Dropdown
    @ViewChild("pDropDownId2", { static: false }) pDropDownId2: Dropdown
    @ViewChild("pDropDownId3", { static: false }) pDropDownId3: Dropdown
    @ViewChild("pDropDownId4", { static: false }) pDropDownId4: Dropdown
    @ViewChild("pMultiSelectId", { static: false }) pMultiSelectId: MultiSelect;
    @ViewChild("fileUpload") documentFileUpload: FileUpload;
    citylist: any[];
    roleArray: any[];
    selectedRole;
    userquery: any;
    proplayerstatus: boolean = false;
    roleName: any;
    defaultStatus: any;
    approveUpdateForm: FormGroup;
    submitted: boolean = false;
    uploadedFiles: any[] = [];
    paymentImage = null;
    public showPicError: boolean = false;
    public showCommentError: boolean = false;
    ageVerificationStatuses: { label: string; value: boolean; }[];
    passportVerificationStatuses: { label: string; value: any; }[];
    filterByPassportVerification: boolean;
    documentData: any[] = [];
    documentRejectForm: FormGroup;
    rejectDocument: boolean = false;
    documentId: any;
    rejectedDocuments: any[] = [];
    showRejectionList: boolean = false;

    displayImagePreview: boolean = false;
    previewImageSrc: string = '';
    zoomScale: number = 1.0;
    panX: number = 0;
    panY: number = 0;
    isDragging: boolean = false;
    private startX: number = 0;
    private startY: number = 0;

    constructor(private commonService: CommonService, private cdr: ChangeDetectorRef, private categoryService: CategoryService, private userService: UserService, private roleService: RoleService, private router: Router, private route: ActivatedRoute, private messageService: MessageService, private confirmationService: ConfirmationService, private formBuilder: FormBuilder) {
        this.methods = [
            { name: 'Aadhar Card' },
            { name: 'Pan Card' },
            { name: 'Passport' },
            { name: 'Birth Certificate' },
            { name: 'Driving Licence' }
        ]
    }

    ngOnInit() {

        this.selectedFilter = this.userFilterByList[0];
        this.paginationOption = environment.pagination;
        this.yearRange = this.minYear + ":" + maxYearFunction();
        this.statuses = [
            { label: 'Active', value: true },
            { label: 'In-Active', value: false }
        ];
        this.searchBy = [
            { label: 'DOB', value: "dob" },
            { label: 'Created On', value: "created_at" },
            { label: 'Last Modified On', value: "updated_at" }
        ];
        this.genders = [
            { label: 'Male', value: 'Male' },
            { label: 'Female', value: 'Female' },
            { label: 'Other', value: 'Other' },
        ];
        this.ageVerificationStatuses = [
            { label: 'Completed', value: true },
            { label: 'Pending', value: false }
        ];
        this.passportVerificationStatuses = [
            { label: 'Completed', value: true },
            { label: 'Pending', value: false },
            { label: 'Rejected', value: 'Rejected' },
        ];
        this.downloadFlg = false;
        //this.getUserlist();
        this.getCategory();
        this.getCities();
        this.getRoleList();
        this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((query) => {
            this.proplayerstatus = (query?.filterByStatus === 'false') ? false : null;
            this.roleName = query?.filterByRoleName;
            this.filterByPassportVerification = (query?.filterByPendingPassportVerification === 'false') ? true : false;
        })
        setTimeout(() => {
            this.defaultStatus = this.statuses.filter((res) => {
                return res.value === this.proplayerstatus;
            })[0]?.value;
        }, 0);
        this.approveUpdateForm = this.formBuilder.group(
            {
                type: [null, { validators: [Validators.required], updateOn: "blur" }],
                image: [null],
            });

        this.documentRejectForm = this.formBuilder.group({
            comment: [null, [Validators.required]]
        })

    }

    openImagePreview(src: string) {
        this.previewImageSrc = src;
        this.zoomScale = 1.0;
        this.panX = 0;
        this.panY = 0;
        this.displayImagePreview = true;
    }

    zoomIn() {
        this.zoomScale = Math.min(this.zoomScale + 0.2, 5.0);
    }

    zoomOut() {
        this.zoomScale = Math.max(this.zoomScale - 0.2, 0.5);
    }

    resetZoom() {
        this.zoomScale = 1.0;
        this.panX = 0;
        this.panY = 0;
    }

    onMouseDown(event: MouseEvent) {
        event.preventDefault();
        this.isDragging = true;
        this.startX = event.clientX - this.panX;
        this.startY = event.clientY - this.panY;
    }

    onMouseMove(event: MouseEvent) {
        if (!this.isDragging) return;
        event.preventDefault();
        this.panX = event.clientX - this.startX;
        this.panY = event.clientY - this.startY;
    }

    onMouseUp() {
        this.isDragging = false;
    }

    onWheel(event: WheelEvent) {
        event.preventDefault();
        if (event.deltaY < 0) {
            this.zoomIn();
        } else {
            this.zoomOut();
        }
    }
    getRoleList() {
        var querystring = "filterByDisable=false&filterByStatus=true";
        this.roleArray = [];
        this.roleService.getRoleList(querystring).pipe(takeUntil(this.destroy$)).subscribe(
            (data) => {
                var roleList = data.data.items;
                roleList.forEach((element) => {
                    if (element.user_role_name !== "admin" && element.user_role_name !== "academy" && element.user_role_name !== "guest") {
                        this.roleArray.push({
                            roleid: element.id,
                            rolename: element.user_role_name,
                        });
                    }
                });
                setTimeout(() => {
                    this.selectedRole = this.roleArray.filter((ele) => {
                        return ele.rolename === this.roleName;
                    })[0];
                }, 0);
            },
            (err) => {
                this.errorMessage = err.error.message;
            }
        );
    }
    onChangeRole(event) {
        console.log('event : ', event);
        this.selectedRole = event.value;
        this.loadUsers(this.lastTableLazyLoadEvent);
    }
    clear() {
        this.startDate = null;
        this.endDate = null;
        this.searchby = '';
        this.dt.filter('', 'fullName', 'contains');
        this.dt.filter('', 'firstName', 'contains');
        this.dt.filter('', 'lastName', 'contains');
        this.dt.filter('', 'countryname', 'contains');
        this.dt.filter('', 'statename', 'contains');
        this.dt.filter('', 'cityname', 'contains');
        this.dt.filter('', 'zipcode', 'contains');
        this.dt.filter('', 'gender', 'contains');
        this.dt.filter('', 'ageGroup', 'contains');
        this.dt.filter('', 'dob', 'dateIs');
        this.dt.filter('', 'weddingDate', 'dateIs');
        this.dt.filter('', 'created_at', 'dateIs');
        this.dt.filter('', 'createdby', 'contains');
        this.dt.filter('', 'updated_at', 'dateIs');
        this.dt.filter('', 'updatedby', 'contains');
        this.dt.filter('', 'mobile', 'contains');
        this.dt.filter('', 'email', 'contains');

        this.calvalue = null;
        this.ucalvalue = null;
        this.dcalvalue = null;
        this.wdcalvalue = null;
        this.defaultStatus = null;
        this.pDropDownId1.clear(null);
        if (this.pDropDownId1) {
            this.pDropDownId1.value = null;
        }
        this.pDropDownId2.clear(null);
        if (this.pDropDownId2) {
            this.pDropDownId2.value = null;
        }
        this.pDropDownId3.clear(null);
        if (this.pDropDownId3) {
            this.pDropDownId3.value = null;
        }
        this.pDropDownId4.clear(null);
        if (this.pDropDownId4) {
            this.pDropDownId4.value = null;
        }
        if (this.pMultiSelectId) {
            this.pMultiSelectId.value = [];
            this.ageGroupList = [];
            this.getCategory();
        }
        this.selectedRole = undefined;
    }
    onRadioButtonClick(selectedValue) {
        this.selectedFilter = selectedValue;
        this.loadUsers(this.lastTableLazyLoadEvent);
    }
    loadUsers(event: LazyLoadEvent) {
        this.lastTableLazyLoadEvent = event;
        var query = "?filterByDisable=false";
        var pagenumber = 1;
        var params = "";
        var rows;
        if (event.first != undefined && event.first == 0) {
            pagenumber = event.first + 1;
        } else if (event.first != undefined && event.first > 0) {
            pagenumber = (event.first / event.rows) + 1;
        } else {
            pagenumber = 1;
        }
        if (event.rows != undefined) {
            rows = event.rows;
        } else {
            rows = 10;
        }
        if (this.selectedFilter.key === "PCMV") {
            query += "&filterByCompleteProfile=true";
            query += "&filterByVerifiedMobile=true";
        }
        if (this.selectedFilter.key === "PCMNV") {
            query += "&filterByCompleteProfile=true";
            query += "&filterByNotVerifiedMobile=true";
        }
        if (this.selectedFilter.key == "IPMV") {
            query += "&filterByInCompleteProfile=true";
            query += "&filterByVerifiedMobile=true";
        }
        if (this.selectedFilter.key == "IPMNV") {
            query += "&filterByInCompleteProfile=true";
            query += "&filterByNotVerifiedMobile=true";
        }
        if (this.selectedFilter.name == "Video Approved") {
            query += "&filterByApprovedVideo=true";
        }
        if (this.selectedFilter.name == "Video Rejected") {
            query += "&filterByRejectedVideo=true";
        }
        if (this.filterByPassportVerification) {
            // query += "&filterByPassPassportRequest=true&filterByisPassportVerified=false&filterByIsAadharVerified=false";
            query += "&filterByisAadharVerified=false&filterByPassPassportRequest=true";
        }
        if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
            params += "&filterByDate=" + this.searchby.value;
            params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
            params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
            // console.log(params);
        }
        if (event.filters != undefined && event.filters["fullName"] != undefined) {
            params += "&filterByfullName=" + event.filters["fullName"].value;
        }
        if (event.filters != undefined && event.filters["firstName"] != undefined) {
            params += "&filterByFirstName=" + event.filters["firstName"].value;
        }
        if (event.filters != undefined && event.filters["lastName"] != undefined) {
            params += "&filterByLastName=" + event.filters["lastName"].value;
        }
        if (event.filters != undefined && event.filters["email"] != undefined) {
            params += "&filterByemail=" + event.filters["email"].value;
        }
        // if (event.filters != undefined && event.filters["countryname"] != undefined){
        //     params += "&filterByCountryName="+event.filters["countryname"].value;            
        // }
        // if (event.filters != undefined && event.filters["statename"] != undefined){
        //     params += "&filterByStateName="+event.filters["statename"].value;            
        // }
        if (event.filters != undefined && event.filters["cityname"] != undefined) {
            params += "&filterByCityName=" + event.filters["cityname"].value.label;
        }
        // if (event.filters != undefined && event.filters["zipcode"] != undefined){
        //     params += "&filterByZipcode="+event.filters["zipcode"].value;            
        // }
        if (event.filters != undefined && event.filters["status"] != undefined) {
            params += "&filterByStatus=" + event.filters["status"].value;
        }
        else if (this.proplayerstatus != undefined) {
            params += "&filterByStatus=" + this.proplayerstatus;
        }
        if (this.roleName != undefined) {
            params += "&filterByRoleName=" + this.roleName;
        }

        if (event.filters != undefined && event.filters["gender"] != undefined) {
            params += "&filterByGender=" + event.filters["gender"].value;
        }
        if (event.filters != undefined && event.filters["ageVerificationStatus"] != undefined) {
            params += "&filterByIsAadharVerified=" + event.filters["ageVerificationStatus"].value;
        }
        if (event.filters != undefined && event.filters["passportVerificationStatus"] != undefined) {
            if (event.filters["passportVerificationStatus"].value === 'Rejected') {
                params += "&filterByisPassportRejected=true&filterByisPassportVerified=false";
            } else {
                params += "&filterByisPassportVerified=" + event.filters["passportVerificationStatus"].value;
            }
        }
        if (event.filters != undefined && event.filters["dob"] != undefined) {
            const dob = moment(event.filters["dob"].value).format("YYYY-MM-DD");
            params += "&filterByDob=" + dob;
        }
        if (event.filters != undefined && event.filters["weddingDate"] != undefined) {
            const weddingDate = moment(event.filters["weddingDate"].value).format("YYYY-MM-DD");
            params += "&filterByWeddingDate=" + weddingDate;
        }
        if (event.filters != undefined && event.filters["created_at"] != undefined) {
            const createdAt = moment(event.filters["created_at"].value).format("YYYY-MM-DD");
            params += "&filterByCreatedAt=" + createdAt;
        }
        if (event.filters != undefined && event.filters["createdby"] != undefined) {
            params += "&filterByCreatedby=" + event.filters["createdby"].value;
        }
        if (event.filters != undefined && event.filters["updated_at"] != undefined) {
            const createdAt = moment(event.filters["updated_at"].value).format("YYYY-MM-DD");
            params += "&filterByUpdatedAt=" + createdAt;
        }
        if (event.filters != undefined && event.filters["updatedby"] != undefined) {
            params += "&filterByUpdatedby=" + event.filters["updatedby"].value;
        }
        if (event.filters != undefined && event.filters["mobile"] != undefined) {
            params += "&filterByMobile=" + event.filters["mobile"].value;
        }
        if (event.filters != undefined && event.filters["ageGroup"] != undefined) {
            params += "&filterByAgeGroup=" + event.filters["ageGroup"].value;
        }

        // at the time of download hide pagination option
        if (this.downloadFlg == false) {
            if (params != undefined && params != "") {
                query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
            } else {
                query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
            }
        }
        else {
            if (params != undefined && params != "") {
                query += params;
            }
        }

        if (event.sortField != undefined && event.sortOrder != undefined) {
            var orderBy = "";
            if (event.sortOrder == 1) {
                orderBy = "DESC";
            } else {
                orderBy = "ASC";
            }
            query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
        }
        // return this.userService.getUserList(query).subscribe(
        //     data => {
        //         this.loading = false;
        //         this.userlist = data.data.items;
        //         this.totalRecords = data.data.totalCount;
        //         this.userlist.forEach(element => {
        //             element.created_at = new Date(element.created_at);
        //         });
        //     },
        //     err => {
        //         this.errorMessage = err.error.message;
        //     }
        // );        
        //var querystring = "filterByroleName=user";
        var querystring = "";
        this.roleService.searchRoleDetails(querystring).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                if (this.downloadFlg === false) {
                    var rolelist = data?.data?.items;
                    var selectedRoles = [];
                    rolelist.forEach(element => {

                        if (element.user_role_name != 'admin' && element.user_role_name != 'academy') {
                            //console.log(element.user_role_name);
                            selectedRoles.push(element.id);
                        }
                    });
                    var roleids = selectedRoles.toString();
                    //console.log(roleids);
                    //this.userRoleId = data.data.items[0]['id'];
                    if (this.selectedRole !== undefined && this.selectedRole !== null) {
                        query += "&filterByrollIds=" + this.selectedRole.roleid;
                    } else {
                        query += "&filterByrollIds=" + roleids;
                    }
                    //query += "&filterByrollIds=" + roleids;
                    this.userService.getUserList(query).pipe(takeUntil(this.destroy$)).subscribe(
                        data => {
                            this.loading = false;
                            this.userlist = data.data?.items;
                            this.cdr.detectChanges();
                            this.totalRecords = data.data?.totalCount;
                            this.userlist.forEach(element => {
                                element.items = [
                                    // {
                                    //   label: 'Edit Player',
                                    //   icon: 'pi pi-pencil',
                                    // //   routerLink: "/manage/customer/user/" + this.userRoleId,
                                    //   command: () => {
                                    //     this.editUser(element.id);
                                    // }
                                    // },
                                    {
                                        label: 'Wallet History',
                                        icon: 'pi pi-wallet',
                                        command: () => {
                                            this.userWallet(element.id);
                                        }
                                    },
                                    {
                                        label: 'Subscription History',
                                        icon: 'pi pi-wallet',
                                        command: () => {
                                            this.userSubscription(element.id);
                                        }
                                    },
                                    {
                                        label: 'Batch Enrolment',
                                        icon: 'pi pi-wallet',
                                        command: () => {
                                            this.userBatchEnrolment(element.id);
                                        }
                                    },
                                    {
                                        label: 'Player Schedule',
                                        icon: 'pi pi-clock',
                                        command: () => {
                                            this.userscheduleList(element.id);
                                        }

                                    },
                                    {
                                        label: 'Tournaments Registration',
                                        icon: 'pi pi-flag',
                                        command: () => {
                                            this.userTournamentLog(element.id);
                                        }
                                    },
                                    {
                                        label: 'Court Bookings',
                                        icon: 'pi pi-money-bill',
                                        command: () => {
                                            this.userCourtLog(element.id);
                                        }
                                    },
                                    {
                                        label: "Player's Achievement",
                                        icon: 'pi pi-flag',
                                        command: () => {
                                            this.userTournamentCertificate(element.id);
                                        }
                                    },
                                    {
                                        label: 'Address Log',
                                        icon: 'pi pi-home',
                                        command: () => {
                                            this.userAddressLog(element.id);
                                        }
                                    },
                                    // {
                                    //   label: 'Ranking List',
                                    //   icon: 'pi pi-chart-line',
                                    //   command: () => {
                                    //     this.rankinggList(element.id);
                                    // }
                                    // },
                                    // {
                                    //     label: 'Opponent List',
                                    //     icon: 'pi pi-user',
                                    //     command: () => {
                                    //         this.opponentList(element.id);
                                    //     }
                                    // },

                                    {
                                        label: 'User kyc',
                                        icon: 'pi pi-verified',
                                        command: () => {
                                            this.userKyc(element.id);
                                        }
                                    },
                                    {
                                        label: 'Matches Information',
                                        icon: 'bx bx-trophy',
                                        command: () => {
                                            this.matchesIfo(element.id);
                                        }
                                    },
                                    // {
                                    //     label: 'Ranking History',
                                    //     icon: 'pi pi-chart-bar',
                                    //     command: () => {
                                    //         this.rankHistory(element.id);
                                    //     }
                                    // },
                                    // {
                                    //     label: 'Skill History',
                                    //     icon: 'pi pi-list',
                                    //     command: () => {
                                    //         this.skillHistory(element.id);
                                    //     }
                                    // },
                                    {
                                        label: 'Bank Details',
                                        icon: 'pi pi-list',
                                        command: () => {
                                            this.router.navigate(['/manage/customer/user/bank-details/' + element.id]);
                                        }
                                    },
                                    {
                                        label: 'Referee List',
                                        icon: 'pi pi-verified',
                                        command: () => {
                                            this.refereeList(element.id, element.fullName);
                                        }
                                    },
                                    // {
                                    //     label: 'Delete User',
                                    //     icon: 'pi pi-trash',
                                    //     command: () => {
                                    //         this.deleteUser(element);
                                    //     }
                                    // },
                                    {
                                        label: 'Upload ID to Verify Age',
                                        icon: 'pi pi-upload',
                                        command: () => {
                                            this.uploadDocument(element);
                                        }
                                    },
                                    {
                                        label: 'My Coaches',
                                        icon: 'pi pi-user',
                                        command: () => {
                                            this.router.navigate(['/manage/customer/user/my-coach/' + element.id]);
                                        }
                                    },

                                ];
                            })
                        },
                        err => {
                            this.errorMessage = err.error.message;
                        });
                } else {
                    var rolelist = data?.data?.items;
                    var selectedRoles = [];
                    rolelist.forEach(element => {

                        if (element.user_role_name != 'admin' && element.user_role_name != 'academy') {
                            //console.log(element.user_role_name);
                            selectedRoles.push(element.id);
                        }
                    });
                    var roleids = selectedRoles.toString();
                    //console.log(roleids);
                    //this.userRoleId = data.data.items[0]['id'];
                    if (this.selectedRole !== undefined && this.selectedRole !== null) {
                        query += "&filterByrollIds=" + this.selectedRole.roleid;
                    } else {
                        query += "&filterByrollIds=" + roleids;
                    }
                    //query += "&filterByrollIds=" + roleids;
                    this.userService.getUserList(query).pipe(takeUntil(this.destroy$)).subscribe(
                        data => {
                            this.loading = false;
                            this.userlist = data.data?.items;
                            this.cdr.detectChanges();
                            this.exportPlayerListData(this.userlist);
                            this.totalRecords = data.data?.totalCount;
                            this.userlist.forEach(element => {
                                element.items = [
                                    // {
                                    //   label: 'Edit Player',
                                    //   icon: 'pi pi-pencil',
                                    // //   routerLink: "/manage/customer/user/" + this.userRoleId,
                                    //   command: () => {
                                    //     this.editUser(element.id);
                                    // }
                                    // },
                                    {
                                        label: 'Wallet History',
                                        icon: 'pi pi-wallet',
                                        command: () => {
                                            this.userWallet(element.id);
                                        }
                                    },
                                    {
                                        label: 'Subscription History',
                                        icon: 'pi pi-wallet',
                                        command: () => {
                                            this.userSubscription(element.id);
                                        }
                                    },
                                    {
                                        label: 'Batch Enrolment',
                                        icon: 'pi pi-wallet',
                                        command: () => {
                                            this.userBatchEnrolment(element.id);
                                        }
                                    },
                                    {
                                        label: 'Player Schedule',
                                        icon: 'pi pi-clock',
                                        command: () => {
                                            this.userscheduleList(element.id);
                                        }

                                    },
                                    {
                                        label: 'Tournaments Registration',
                                        icon: 'pi pi-flag',
                                        command: () => {
                                            this.userTournamentLog(element.id);
                                        }
                                    },
                                    {
                                        label: 'Court Bookings',
                                        icon: 'pi pi-money-bill',
                                        command: () => {
                                            this.userCourtLog(element.id);
                                        }
                                    },
                                    {
                                        label: "Player's Achievement",
                                        icon: 'pi pi-flag',
                                        command: () => {
                                            this.userTournamentCertificate(element.id);
                                        }
                                    },
                                    {
                                        label: 'Address Log',
                                        icon: 'pi pi-home',
                                        command: () => {
                                            this.userAddressLog(element.id);
                                        }
                                    },
                                    // {
                                    //   label: 'Ranking List',
                                    //   icon: 'pi pi-chart-line',
                                    //   command: () => {
                                    //     this.rankinggList(element.id);
                                    // }
                                    // },
                                    {
                                        label: 'Opponent List',
                                        icon: 'pi pi-user',
                                        command: () => {
                                            this.opponentList(element.id);
                                        }
                                    },

                                    {
                                        label: 'User kyc',
                                        icon: 'pi pi-verified',
                                        command: () => {
                                            this.userKyc(element.id);
                                        }
                                    },
                                    {
                                        label: 'Matches Information',
                                        icon: 'bx bx-trophy',
                                        command: () => {
                                            this.matchesIfo(element.id);
                                        }
                                    },
                                    {
                                        label: 'Ranking History',
                                        icon: 'pi pi-chart-bar',
                                        command: () => {
                                            this.rankHistory(element.id);
                                        }
                                    },
                                    {
                                        label: 'Skill History',
                                        icon: 'pi pi-list',
                                        command: () => {
                                            this.skillHistory(element.id);
                                        }
                                    },
                                    {
                                        label: 'Bank Details',
                                        icon: 'pi pi-list',
                                        command: () => {
                                            this.router.navigate(['/manage/customer/user/bank-details/' + element.id]);
                                        }
                                    },
                                    {
                                        label: 'Referee List',
                                        icon: 'pi pi-verified',
                                        command: () => {
                                            this.refereeList(element.id, element.fullName);
                                        }
                                    },
                                    {
                                        label: 'Delete User',
                                        icon: 'pi pi-trash',
                                        command: () => {
                                            this.deleteUser(element);
                                        }
                                    },
                                    {
                                        label: 'Upload Document',
                                        icon: 'pi pi-upload',
                                        command: () => {
                                            this.uploadDocument(element);
                                        }
                                    },

                                ];
                            })
                        },
                        err => {
                            this.errorMessage = err.error.message;
                        });
                }
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    deleteUser(user) {
        this.confirmationService.confirm({
            // message: 'Are you sure you want to delete ' + (this.titlecasePipe.transform(user.fullName)) + '?',
            // header: 'Confirm',
            // icon: 'pi pi-exclamation-triangle',
            message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to delete this user ?
      </p>
    `,
            // message: 'Are you sure you want to delete this image ?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Confirm',
            rejectLabel: 'Cancel',
            // ❌ Remove icons
            acceptIcon: '',
            rejectIcon: '',
            accept: () => {
                var disableStatus;
                if (user.disable == false) {
                    disableStatus = true;
                } else {
                    disableStatus = false;
                }
                var userData = '{"disable":' + disableStatus + '}';
                this.userService.updateUser(user.id, userData).pipe(takeUntil(this.destroy$)).subscribe(
                    data => {
                        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Deleted', life: 3000 });
                        this.loadUsers(this.lastTableLazyLoadEvent);
                    },
                    err => {
                        this.errorMessage = err.error.message;
                    }
                );
            },
            reject: () => {
                //this.getUserDetails(user.id);
            }
        });
    }

    refereeList(id, fullName) {
        this.router.navigate(["/manage/academies/refereeList/" + id], { queryParams: { referralName: fullName } });
    }

    func(prop, val) {
        var jsonStr = '{"' + prop + '":"' + val + '"}';
        return JSON.parse(jsonStr);
    }

    addNewUser() {
        this.router.navigate(['/manage/user/add']);
    }

    viewUser(id) {
        this.router.navigate(['/manage/customer/user/view/' + id]);
    }
    userWallet(id) {
        this.router.navigate(['/manage/customer/user/wallet/' + id]);
    }

    userSubscription(id) {
        this.router.navigate(['/manage/customer/user/user-subscription/' + id]);
    }

    userBatchEnrolment(id) {
        this.router.navigate(['/manage/customer/user/user-batch-enrolment/' + id]);
    }

    userTournamentLog(id) {
        this.router.navigate(['/manage/customer/user/player-tournament/' + id]);
    }
    userCourtLog(id) {
        this.router.navigate(['/manage/customer/user/player-courts/' + id]);
    }
    userTournamentCertificate(id) {
        this.router.navigate(['/manage/customer/user/player-certificate/' + id]);
    }
    userAddressLog(id) {
        this.router.navigate(['/manage/customer/user/addresslog/' + id]);
    }

    editUser(id) {
        this.router.navigate(['/manage/customer/user/' + id]);
    }

    userscheduleList(id) {
        this.router.navigate(['/manage/customer/user/userscheduleList/' + id]);
    }
    rankinggList(id) {
        this.router.navigate(['/manage/user/ranking-list/' + id]);
    }
    opponentList(id) {
        this.router.navigate(['/manage/user/skilled-opponent/' + id]);
    }
    userKyc(id) {
        this.router.navigate(['/manage/customer/user/kyc/' + id]);
    }
    matchesIfo(id) {
        this.router.navigate(['/manage/user/matches-info/' + id]);
    }
    rankHistory(id) {
        this.router.navigate(['/manage/user/ranking-history/' + id]);
    }
    skillHistory(id) {
        this.router.navigate(['/manage/user/skill-history/' + id]);
    }
    findIndexById(id: string): number {
        let index = -1;
        for (let i = 0; i < this.userlist.length; i++) {
            if (this.userlist[i].id === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    changeStatus(user) {
        this.confirmationService.confirm({
            // message: 'Are you sure you want to change the status of  ' + (this.titlecasePipe.transform(user.fullName)) + '?',
            // header: 'Confirm',
            // icon: 'pi pi-exclamation-triangle',
            message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to change this status ?
      </p>
    `,

            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Confirm',
            rejectLabel: 'Cancel',
            // ❌ Remove icons
            acceptIcon: '',
            rejectIcon: '',
            accept: () => {

                var userData = '{"status":' + user.status + '}';
                this.userService.updateUser(user.id, userData).pipe(takeUntil(this.destroy$)).subscribe(
                    data => {
                        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Status Updated', life: 3000 });
                        //this.getUserDetails(user.id);
                        this.loadUsers(this.lastTableLazyLoadEvent);
                    },
                    err => {
                        this.errorMessage = err.error.message;
                    }
                );
            },
            reject: () => {
                //this.getUserDetails(user.id);
                this.loadUsers(this.lastTableLazyLoadEvent);
            }
        });
    }

    getUserDetails(id) {
        this.userService.getUserDetails(id).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.userdetail = data;
                this.userdetail.created_at = new Date(this.userdetail.created_at);
                this.userdetail.name = this.userdetail.firstName + ' ' + this.userdetail.lastName;
                if (this.userdetail.status == true) {
                    this.userdetail.statusactive = true;
                } else {
                    this.userdetail.statusactive = false;
                }
                this.userlist[this.findIndexById(id)] = this.userdetail;
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }
    /** 
     * Use to add more columns in the table.
    */
    // addColumns() {
    //     var showp1Table = this.el.nativeElement.querySelector(".p1-table-columns");
    //     showp1Table.classList.remove('hide-columns');
    //     showp1Table.classList.add('show-columns');
    //     var hidep2Table = this.el.nativeElement.querySelector(".p2-table-columns");
    //     hidep2Table.classList.remove('show-columns');
    //     hidep2Table.classList.add('hide-columns');
    // }

    // /** 
    // * Use to remove more columns in the table.
    // */
    // removeColumns() {
    //     var showp2Table = this.el.nativeElement.querySelector(".p2-table-columns");
    //     showp2Table.classList.remove('hide-columns');
    //     showp2Table.classList.add('show-columns');
    //     var hidep1Table = this.el.nativeElement.querySelector(".p1-table-columns");
    //     hidep1Table.classList.add('hide-columns');
    //     hidep1Table.classList.remove('show-columns');
    // }

    setDownloadFlag() {
        this.downloadFlg = false;
    }

    exportExcel() {
        this.downloadFlg = true;
        this.loadUsers(this.lastTableLazyLoadEvent);
    }

    exportPlayerListData(userlist) {
        this.downloadUserList = userlist;
        var propertiesRemove = ['fullName', 'countrycode', 'statecode', 'citycode', 'portfolioImages', 'items', 'Wedding_Date', 'id', 'country_id', 'state_id', 'city_id', 'zipcode', 'created_at', 'dob', 'weddingDate', 'role', 'profilepic', 'createdby', 'updatedby', 'disable', 'updated_at'];
        this.downloadUserList.forEach(function (item) {
            if (item.updated_at != '') {
                item['Modification_Date'] = moment(item.updated_at).format('DD-MM-YYYY');
            }
            if (item.dob != '') {
                item['Date_Of_Birth'] = moment(item.dob).format('DD-MM-YYYY');
            }
            if (item.isMobileVerified) {
                item['isMobileVerified'] = 'Yes';
            } else {
                item['isMobileVerified'] = 'No';
            }

            if (item.isAadharVerified) {
                item['age_Verification'] = 'Completed';
            } else {
                item['age_Verification'] = 'Pending';
            }

            if (item.status) {
                item['status'] = 'Active';
            } else {
                item['status'] = 'In-Active';
            }

            if (item.weddingDate != '') {
                item['Wedding_Date'] = moment(item.weddingDate).format('DD-MM-YYYY');
            }
            propertiesRemove.forEach(function (prop) {
                delete item[prop];
            });
        });
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.downloadUserList);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer: any = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });
            this.saveAsExcelFile(excelBuffer, "Player List");
        });
        this.downloadFlg = false;
    }


    saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            let EXCEL_EXTENSION = ".xlsx";
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            let filename;
            filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
            saveAs(data, filename);
        });
    }
    getCategory() {
        var query =
            "?filterByDisable=false&filterByStatus=true&filterBySlug=tournament_junior_agegroup&sortBy=created_at&orderBy=1";
        this.categoryService.getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe((data) => {
            var query =
                "?filterByDisable=false&filterByStatus=true&filterByParent=" +
                data.data.items[0]["id"] +
                "&sortBy=created_at&orderBy=1";
            this.categoryService.getCategoryDetailsWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe(
                (data) => {
                    var catlist = data.data.items;
                    catlist.forEach((element) => {
                        let obj = {
                            label: element.name,
                            value: element.slug,
                        };
                        this.ageGroupList.push(obj);
                    });
                    var query =
                        "?filterByDisable=false&filterByStatus=true&filterBySlug=tournament_senior_agegroup&sortBy=created_at&orderBy=1";
                    this.categoryService
                        .getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$))
                        .subscribe((data) => {
                            var query =
                                "?filterByDisable=false&filterByStatus=true&filterByParent=" +
                                data.data.items[0]["id"] +
                                "&sortBy=created_at&orderBy=1";
                            this.categoryService
                                .getCategoryDetailsWithoutAuthList(query).pipe(takeUntil(this.destroy$))
                                .subscribe(
                                    (data) => {
                                        var catlist = data.data.items;
                                        catlist.forEach((element) => {
                                            let obj = {
                                                label: element.name,
                                                value: element.slug,
                                            };
                                            this.ageGroupList.push(obj);
                                        });
                                        //console.log(this.agecatlist);
                                    },
                                    (err) => {
                                        this.errorMessage = err.error.message;
                                    }
                                );
                        });
                },
                (err) => {
                    this.errorMessage = err.error.message;
                }
            );
        });
    }
    getCities() {

        var query = "?filterByDisable=false&filterByStatus=true&sortBy=name&orderBy=ASC&filtercityByCountryCode=IN";
        this.commonService.getCities(query).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.citylist = [];
                var cities = data.data.items;
                cities.forEach(city => {
                    this.citylist.push({ label: city.name, name: city.id });
                });
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    uploadDocument(user) {
        this.paymentType = true;
        this.userId = user.id;
        this.documentData = user?.documents;
        if (this.documentData.length !== 0) {
            // let documentType = this.methods.find(method => method.name === user?.documents[0]?.type);
            this.documentId = user?.documents[0]?._id;
            // if (documentType) {
            //     this.approveUpdateForm.patchValue({
            //         type: documentType,
            //     })
            // }
        } else {
            this.approveUpdateForm.get('image').setValidators([Validators.required]);
            this.approveUpdateForm.get('image').updateValueAndValidity();
        }
    }

    onDocumentmodalModalClose() {
        this.submitted = false;
        if (this.documentFileUpload) {
            this.documentFileUpload.clear();
        }
        this.approveUpdateForm.reset();
        this.documentRejectForm.reset();
        this.paymentType = false;
        this.rejectDocument = false;
    }

    onRejectDocumentModalClose() {
        this.rejectDocument = false;
    }

    get f() {
        return this.approveUpdateForm.controls;
    }

    // get h() {
    //     return this.rejectUpdateForm.controls;
    // }

    onDropdownClear() {
        this.selectedMethod = null;
        this.approveUpdateForm.get('type').setValue(null);
    }
    approveuser() {
        this.submitted = true;
        if (this.approveUpdateForm.invalid) {
            return;
        }

        let updateData = this.approveUpdateForm.value;
        updateData["type"] = updateData['type']['name'];
        updateData["userId"] = this.userId;
        updateData["approved"] = true;

        if (this.documentData.length === 0) {
            if (this.paymentImage === undefined || this.paymentImage === null) {
                this.showPicError = true;
                return;
            } else {
                this.showPicError = false;
            }
            this.userService.addUserDocument(updateData).pipe(takeUntil(this.destroy$))
                .subscribe(
                    (data) => {
                        this.messageService.add({
                            key: "toastmsg",
                            severity: "success",
                            summary: "Successful",
                            detail: "Document Added Successfully",
                            life: 3000,
                        });
                        this.onDocumentmodalModalClose();
                        //this.getUserDetails(data.id);
                        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                        this.router.onSameUrlNavigation = "reload";
                        this.router.navigate(["/manage/customer/user"]);
                        //this.userRedemptionId = null

                    },
                    (err) => {
                        this.messageService.add({ key: "toastmsg", severity: "error", summary: "Error", detail: err.error.error, life: 3000 });
                    }
                );
        } else {
            this.confirmationService.confirm({
                message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to change the status to Approved ?
      </p>
    `,
                // message: 'Are you sure you want to delete this image ?',
                header: 'Confirm',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Confirm',
                rejectLabel: 'Cancel',
                // ❌ Remove icons
                acceptIcon: '',
                rejectIcon: '',
                accept: () => {
                    delete updateData['image'];
                    this.userService.updateUserDocument(this.documentId, updateData).pipe(takeUntil(this.destroy$))
                        .subscribe(
                            (data) => {
                                this.messageService.add({
                                    key: "toastmsg",
                                    severity: "success",
                                    summary: "Successful",
                                    detail: "Document Updated Successfully",
                                    life: 3000,
                                });
                                this.onDocumentmodalModalClose();
                                //this.getUserDetails(data.id);
                                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                                this.router.onSameUrlNavigation = "reload";
                                this.router.navigate(["/manage/customer/user"]);
                                //this.userRedemptionId = null

                            },
                            (err) => {
                                this.messageService.add({ key: "toastmsg", severity: "error", summary: "Error", detail: err.error.error, life: 3000 });
                            }
                        );
                },
                reject: () => {
                    //this.getUserDetails(data.id);
                },
            });
        }
        // }
    }
    picUploader(event) {
        for (let file of event.files) {
            this.uploadedFiles.push(file);
            var reader = new FileReader();
            reader.readAsDataURL(this.uploadedFiles[0]);
            reader.onload = () => {
                // called once readAsDataURL is completed
                this.paymentImage = reader.result;
                this.approveUpdateForm.get('image').setValue(reader.result);
            };
        }
    }
    removeFile() {
        this.uploadedFiles = [];
        this.paymentImage = undefined;
        this.approveUpdateForm.get('image').setValue(null);
        this.approveUpdateForm.get('image').setValidators([Validators.required]);
        this.approveUpdateForm.get('image').updateValueAndValidity();
    }

    showPassportRejectionReasonList(user) {
        this.showRejectionList = true;
        this.rejectedDocuments = user.rejectedDocuments;
    }

    rejectuser() {
        this.submitted = true;
        if (this.approveUpdateForm.invalid) {
            return;
        }
        this.rejectDocument = true;
    }

    submitRejectionForm() {
        if (this.documentRejectForm.invalid) {
            this.showCommentError = true;
            return;
        }

        let updateData = this.approveUpdateForm.value;
        updateData["userId"] = this.userId;
        updateData["type"] = updateData['type']['name'];
        updateData['comment'] = this.documentRejectForm.value.comment;
        updateData['rejected'] = true;
        delete updateData['image'];

        this.userService.updateUserDocument(this.documentId, updateData).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
            this.messageService.add({ key: "toastmsg", severity: "error", summary: "Error", detail: "Document has been rejected!!", life: 6000, });
            this.onDocumentmodalModalClose();
            //this.getUserDetails(data.id);
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = "reload";
            this.router.navigate(["/manage/customer/user"]);
            //this.userRedemptionId = null
        }, err => {
            this.messageService.add({ key: "toastmsg", severity: "error", summary: "Error", detail: err.error.error, life: 3000 });
        })
    }
    addColumns() {
        this.hide = false;

    }

    /**
    * Use to remove more columns in the table.
    */
    removeColumns() {
        this.hide = true;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
